import React, { Children, useEffect, useState } from 'react'
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Row, Col, Card, CardTitle, CardText, Input } from "reactstrap";
import { callAPI } from "../../_helper/index";
import ReactHighcharts from 'react-highcharts';
import Select from "react-dropdown-select";
import { Spinner } from 'reactstrap';
import { toast } from "react-toastify";

function Dashboard() {
    const [mapData, setmapData] = useState([])
    const [chartData, setchartData] = useState()
    const [Days, setDays] = useState([])
    const [PastTrips, setPastTrips] = useState()
    const [PendingTrip, setPendingTrip] = useState()
    const [totalDay, settotalDay] = useState()
    const [TotalHousr, setTotalHousr] = useState()
    const [pendingTripOrder, setpendingTripOrder] = useState()
    const [pastTripOrder, setpastTripOrder] = useState()
    const [cancelTrips, setCancelTrips] = useState()
    const [totalKM, setTotalKM] = useState()
    
    const [dropDownList, setdropDownList] = useState([
        { label: "All", value: "all", }
    ])
    const [IsLoading, setIsLoading] = useState(true)
    const [userData, setuserData] = useState([])
    useEffect(() => {
        var response = callAPI(`/api/matrics/all`, "GET", null)
        response.then((res) => {
        console.log(res);
            setmapData(res.chartData)
            res.data.map(el => {
            console.log(el.TotalKM);
                setPastTrips(el.PastTrips)
                setPendingTrip(el.PendingTrip)
                settotalDay(el.TotalDay)
                setTotalHousr(el.TotalHours)
                setIsLoading(false)
                setpendingTripOrder(el.PendingTripOrders)
                setpastTripOrder(el.PastTripOrders)
                setCancelTrips(el.CancelledTrips)
                setTotalKM(el.TotalKM)
            })
        });

        let userArr = []
        // userdata for dropdown
        callAPI(`/api/userlist`, "GET", null)
            .then((re) => {
                setIsLoading(false)
                re.data.map(el => {
                    userArr.push({
                        ["label"]: el.UserName,
                        ["value"]: el.Id
                    })
                })
                setuserData(userArr)
            }).catch((err) => {
                toast.error(err);
            });

    }, [])

    let allDays = []
    let allTotal = []
    let chartDataArr = []
    useEffect(() => {
        if (mapData) {
            mapData.forEach(el => {
                allDays.push(el.SDay)
                setDays(allDays)
                allTotal.push(el.Total)
            })
            for (let i = 0; i < mapData.length; i += 1) {
                chartDataArr.push([allDays[i], allTotal[i]])
            }
            setchartData(chartDataArr)
        }

    }, [mapData]);

    var config = {
        rangeSelector: {
            selected: 1
        },
        
        title: {
            text: 'Pending Trip'
        },
        chart: {
            type: 'column'
        },
        xAxis: {
            categories: Days
        },
        series: [{
            name: 'Days',
            data: chartData,
            color:'#2CA8FF',
            tooltip: {
                valueDecimals: 2
            }
        }]
    };
    const cardData = [
        { title: PendingTrip, subTitle: "Pending", text: pendingTripOrder ? `Trips / ${pendingTripOrder} Order` : "Trips", icon: <i class="now-ui-icons location_pin dash-icon "></i> },
        { title: PastTrips, subTitle: "Past Trip", text: pastTripOrder ? `This Week / ${pastTripOrder} Order` : "This Week", icon: <i class="now-ui-icons shopping_delivery-fast dash-icon"></i> },
        { title: totalKM , subTitle: "Kilometers", text: "This Week", icon: <i class="now-ui-icons sport_user-run dash-icon"></i> },
        { title: TotalHousr, subTitle: "Hours", text: "This Week", icon: <i class="now-ui-icons tech_watch-time dash-icon"></i> },
        { title: totalDay, subTitle: "Day", text: "This Week", icon: <i class="now-ui-icons ui-1_calendar-60 dash-icon" ></i> },
        { title:cancelTrips, subTitle: "Cancle Trips", text: "This Week", icon: <i class="now-ui-icons files_box dash-icon"></i> },
    ]

    const onListDataChange = (value) => {
        setIsLoading(true)
        setdropDownList(value)
        value.map(el => {

            callAPI(`/api/matrics/all/${el.value}`, "GET")
                .then((res) => {
                console.log(res);
                    setIsLoading(false)
                    setmapData(res.chartData)
                    setIsLoading(false)
                    res.data.map(el => {
                        setPastTrips(el.PastTrips)
                        setPendingTrip(el.PendingTrip)
                        settotalDay(el.TotalDay)
                        setTotalHousr(el.TotalHours)
                        setpendingTripOrder(el.PendingTripOrders)
                        setpastTripOrder(el.PastTripOrders)
                        setCancelTrips(el.CancelledTrips)
                        setTotalKM(el.TotalKM)
                    })
                }).catch((err) => {
                    toast.error(err);
                });
        })
    }

  
    return (
        <>
            <PanelHeader size="lg" />
            {
                IsLoading &&
                <div className="loader">
                    <Spinner color="white" />
                </div>

            }
            <div className="content dashboard">
                <Row lg="3" md="6">
                    <Col>
                        <div className="form-group">
                            <label for="list" className="text-white mb-0 pl-1">
                                Choose Driver:
                            </label>
                            <Select
                                name="List"
                                values={dropDownList}
                                onChange={(value) => onListDataChange(value)}
                                options={userData}
                                className="form-control bg-white rounded border-0"
                                placeholder="search user.."
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    {
                        cardData.map(item => (
                            <Col lg="4" md="6">
                                <Card className="bg-white rounded p-3">
                                    <Row><Col className="d-flex justify-content-between align-items-center mb-2">
                                        <CardTitle tag="h3" className="mb-0">{item.title}</CardTitle>
                                        {item.icon}
                                    </Col></Row>
                                    <CardText tag="h5">{item.subTitle}</CardText>
                                    <CardText>{item.text}</CardText>
                                </Card>
                            </Col>
                        ))
                    }
                </Row>
                <Row>
                    <Col>
                        <ReactHighcharts config={config}></ReactHighcharts>
                    </Col>
                </Row>
            </div>
        </>
    )
}
export default Dashboard
